
export type ActivateSubscriptionBody = { [key: string]: unknown };
